import { RESET } from '../actionTypes';
import { interactiveProposalPreviewActions } from '../reducer';

export default () => interactiveProposalPreviewActions[RESET]();
